const NO_ELEMENTS = 0

export function exists($element) {
  if($element.length > NO_ELEMENTS) {
    return true
  }

  return false
}
